/***
 *
 *统一定义接口，有利于维护
 *
 **/
import React from 'react';
const URL= 'https://app.kpcx179.com/';//开发环境
React.$addressone= URL
export default URL
